import { flow, flatMap, uniq, map, keys, get, __, getOr } from 'lodash/fp';

export type NormalizeRowsInput = {
  headers: string[];
  headerMapping?: Record<string, string>;
  rows?: any[] | null;
};

type NormalizeRowsOutput = {
  columns: string[];
  headRows: string[];
  bodyRows: any[][];
};

export const normalizeRows = ({
  headers,
  headerMapping,
  rows,
}: NormalizeRowsInput): NormalizeRowsOutput => {
  const columns = headers || flow(flatMap(keys), uniq)(rows);

  const headRows = map((key) => getOr(key, key, headerMapping), columns);
  const bodyRows = map((row) => map(get(__, row), columns))(rows);

  return {
    columns,
    headRows,
    bodyRows,
  };
};
